import _ from 'lodash';
import findByString from "./getValueByString";

export const valueHandlerForStringArray = (values, path, arrayValues) => {
    let value = findByString(values, path);
    if (typeof value === "string") {
        value = [value]
    }
    if (path) {
        (value || []).forEach((value) => {
            arrayValues.push({label: value, value: value})
        });
        return arrayValues;
    }
};

export const autocompleteArray = (values, path, arrayValues) => {
    let value = findByString(values, path);
    (value || []).forEach((value) => {
        arrayValues.push(value)
    });
    return arrayValues;
};

export const valueHandlerDefault = (values, path, simpleValue) => {
    if (path) {
        simpleValue = findByString(values, path);
        return simpleValue;
    }
};

export const valueHandlerCollection = (values, path, selectedValues) => {
    if (path) {
        if (!findByString(values, path)) {
            return selectedValues = {value: '', label: ''}
        } else {
            selectedValues = {value: findByString(values, path), label: findByString(values, path)};
            return selectedValues;
        }
    }
    return selectedValues;
};

export const valueHandlerCollectionArray = (values, path, arrayValues) => {
    if (path) {
        (findByString(values, path) || []).forEach((value, index) => {
            arrayValues.push({value: value, label: value, index})
        })
    }
    return arrayValues;
};

export const valueHandlerCollectionArrayWithEnri = (enriValues, values, path, arrayValues) => {
    if (path) {
        const origvalue = findByString(values, path);
        const enriValue = findByString(enriValues, path);
        if (origvalue && enriValue) {
            for (let i = 0; i < origvalue.length; i++) {
                arrayValues.push({value: origvalue[i], label: enriValue[i], index: i})
            }
        }
    }
    return arrayValues;
};

export const valueHandlerFrequency = (values, path, currentValue, valuesLength) => {
    if (path) {
        currentValue = findByString(values, path);
        if (!currentValue) {
            valuesLength = 0;
            currentValue = '';
        }
    }


    return {currentValue, valuesLength};
};

export const valueHandlerAutoComplete = (values, path, options) => {
    if(path){
        let value = findByString(values, path);
        let objValue = _.find(options, (v) => {return v.value === value}) || {};
        return {value: objValue.name || '', label: objValue.label || ''};
    }

};
